import { BuilderBlocks } from '@builder.io/react';
import { FC, useCallback, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import styles from './b2b-collapse.module.scss';

interface CollapseItem {
    title: string;
    content: any;
}
export interface B2BCollapseProps {
    builderBlock: {
        id: string;
    };
    item: CollapseItem;
}

const B2BCollapse: FC<B2BCollapseProps> = (props) => {
    const { item } = props;

    const [active, setActive] = useState(false);
    const contentContainerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);

    const _toggleShowHide = () => {
        try {
            if ((props.builderBlock as any).meta?.eventActions?.click?.[0]?.options?.code) {
                eval(`(function() {${(props.builderBlock as any).meta?.eventActions?.click?.[0]?.options?.code}}())`);
            }
        } catch (ex) {
            console.error(ex);
        }
        setActive(!active);
        if (!contentRef.current) return;
        if (!contentContainerRef.current) return;

        if (active) {
            contentContainerRef.current.style.maxHeight = '0px';
        } else {
            contentContainerRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
        }
    };

    const _onResize = useCallback(() => {
        if (!active) return;
        if (!contentRef.current) return;
        if (!contentContainerRef.current) return;

        contentContainerRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
    }, [active, contentRef, contentContainerRef]);

    useEffect(() => {
        if (!contentRef.current) return;
        const target = contentRef.current;

        const observer = new ResizeObserver(_onResize);
        observer.observe(target);
        return () => {
            observer.unobserve(target);
        };
    }, [contentRef, _onResize]);

    if (!item) return null;

    return (
        <div className={classNames(styles.accordion, { [styles.active]: active })}>
            <button className={styles.button} onClick={_toggleShowHide}>
                <div dangerouslySetInnerHTML={{ __html: item.title }} />
                <span className={styles.symbol} />
            </button>
            <div ref={contentContainerRef} className={styles.contentContainer}>
                <div ref={contentRef} className={styles.content}>
                    <BuilderBlocks parent={props.builderBlock.id} dataPath={'component.options.item.content'} blocks={item.content} />
                </div>
            </div>
        </div>
    );
};

export default B2BCollapse;
